<template>
    <div>
        <textarea :id="id"></textarea>
    </div>
</template>
<script>
    export default {
        name: 'ckeditor',
        props: ['value','config'],
        mounted: function() {
            const self = this;
            // 渲染编辑器
            self.config.on = {
                pluginsLoaded: function() {
                    var editor = this,
                        config = editor.config;
                     config.toolbar = 'Full'   
                        
                    editor.ui.addRichCombo( 'uploadImg', {
                        label: '选择图片',
                        title: '选择图片',
                        toolbar: 'basicstyles,0',

                        panel: {
                            css: [ CKEDITOR.skin.getPath( 'editor' ) ].concat( config.contentsCss ),
                            multiSelect: false,
                            attributes: { 'aria-label': '下拉选择框' }
                        },

                        init: function() {
                            this.startGroup( '选择图片' );
                            this.add( '本地图片', '本地图片' );
                            this.add( '网络图片', '网络图片' );
                        },

                        onClick: function( value ) {
                           if(value == '网络图片'){
                               self.$emit('open','online');
                           }else if(value == '本地图片'){
                               self.$emit('open','local');
                           }
                        }
                    } );
                },
                instanceReady: function( ev ) {
                    // Output paragraphs as <p>Text</p>.
                    this.dataProcessor.writer.setRules( 'p', {
                        indent: false,
                        breakBeforeOpen: true,
                        breakAfterOpen: false,
                        breakBeforeClose: false,
                        breakAfterClose: true
                    });
                }
            };

            self.ckeditor = window.CKEDITOR.replace(self.id,self.config);

            // 设置初始内容
            self.ckeditor.setData(self.value);

            // 监听内容变更事件
            self.ckeditor.on('change', function() {
                // self.$emit('input', self.ckeditor.getData())
            });
            self.ckeditor.on('instanceReady', function(e) {
                //监听粘贴事件
                this.document.on("paste", function(e) {
                    var items = e.data.$.clipboardData.items;
                    for(var i = 0; i < items.length; ++i) {
                        var item = items[i];
                        if(item.kind == 'file' && (item.type == 'image/png' || item.type == 'image/jpeg')) {
                            var imgFile = item.getAsFile();
                            if(!imgFile) {
                                return true;
                            }
                            var reader = new FileReader();
                            reader.readAsDataURL(imgFile);
                            reader.onload = function(e) {
                                //显示文件
                                self.ckeditor.insertHtml('<img src="' + this.result + '" alt="" />');
                            }
                            return false;
                        }
                    }
                });
            });
            self.$emit('getCkEditorInstance',self.ckeditor);
        },
        data: function() {
            return {
                id: parseInt(Math.random() * 10000).toString(),
                ckeditor: null
            }
        },
        watch: {
            // 监听prop的变化，更新ckeditor中的值
            value: function() {
               this.insertData(this.value);
                // this.ckeditor.updateElement();
            }
        },
        methods:{
            insertData(data){//递归插入，处理第二次实例化的时候数据没有插入
                let that = this;
                if(data !== undefined){
                    this.ckeditor.setData(data,()=>{
                        if(that.ckeditor.getData() == null){
                            that.insertData(data);
                        }
                    });
                    this.ckeditor.updateElement();
                }

            },
             setData(data) {
                if (data !== undefined) {
                    this.ckeditor.setData()
                    this.ckeditor.updateElement()
                }
                },
        },
        // 销毁组件前，销毁编辑器
        beforeDestroy: function() {
            this.ckeditor.destroy(false)
        }
    }
</script>
